var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"id":'type-' + _vm.type,"type":_vm.type}})}
var staticRenderFns = []

export { render, staticRenderFns }